import accountingAccountingDE from './messages/accounting/accounting.json';
import accountingChargeDE from './messages/accounting/charge.json';
import accountingReportingDE from './messages/accounting/reporting.json';
import accountingStatementDE from './messages/accounting/statement.json';
import agencyRatesDE from './messages/agencyRates.json';
import communicationsDE from './messages/communications.json';
import contactDE from './messages/contact.json';
import enumsDE from './messages/enums.json';
import foldersDE from './messages/folders.json';
import leaseAddLeaseDE from './messages/lease/addLease.json';
import leaseDetailDE from './messages/lease/detail.json';
import leaseLeaseDE from './messages/lease/lease.json';
import remainingMessagesDE from './messages/messages.json';
import myCompanyDE from './messages/myCompany.json';
import paymentsDE from './messages/payments.json';
import rentalUnitDE from './messages/rentalUnit.json';
import settingsDE from './messages/settings.json';
import templatesDE from './messages/templates.json';
import transactionsDE from './messages/transactions.json';

export const BackendMessagesDE = {
  accounting: {
    statement: accountingStatementDE,
    reporting: accountingReportingDE,
    charge: accountingChargeDE,
    ...accountingAccountingDE,
  },
  agencyRates: agencyRatesDE,
  communications: communicationsDE,
  contact: contactDE,
  enums: enumsDE,
  folders: foldersDE,
  lease: {
    ...leaseLeaseDE,
    detail: leaseDetailDE,
    addLease: leaseAddLeaseDE,
  },
  myCompany: myCompanyDE,
  rentalUnit: rentalUnitDE,
  settings: settingsDE,
  templates: templatesDE,
  payments: paymentsDE,
  transactions: transactionsDE,
  ...remainingMessagesDE,
};
